import request from '@/utils/request'

const activitiesPrizeClaimURL = {
  List: '/platform-activity/record',
  Update: '/platform-activity/grant'
}

// 获奖列表 & 详情(参数传id = *)
export function fetchActivitiesPrizeClaimList (params) {
  return request({
    url: activitiesPrizeClaimURL.List,
    method: 'get',
    params
  })
}

// 修改
export function updateActivitiesPrizeClaim (data) {
  return request({
    url: activitiesPrizeClaimURL.Update,
    method: 'post',
    data
  })
}

export default {
  fetchActivitiesPrizeClaimList,
  updateActivitiesPrizeClaim
}
